export default "__VITE_ASSET__ivWZml0y__"